import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import DateInput from "modules/reports/DateInput";
import CardDiv from "modules/common/card-div/CardDiv";

function Reports() {
  const [key, setKey] = useState("ACTIVE_CUSTOMER_REPORT");
  return (
    <div className="bg-white rounded-top pt-2 shadow">
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab
          eventKey="ACTIVE_CUSTOMER_REPORT"
          title="Active Customer Report"
          className="border-bottom"
          style={{ height: "15rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Active Customer Report</div>}
            component={<DateInput tab={key} />}
          />
        </Tab>
        <Tab
          eventKey="WEEKLY_ENGAGEMENT_ANSWERED_REPORT"
          title="Weekly Answered Report"
          className="border-bottom border-x"
          style={{ height: "15rem" }}
        >
          <CardDiv
            title={
              <div className="fs-2">Weekly Engagement Answered Report</div>
            }
            component={<DateInput tab={key} />}
          />
        </Tab>
        <Tab
          eventKey="UNORDERED_REPORT"
          title="Unordered Report"
          className="border-bottom border-x"
          style={{ height: "15rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Unordered Report</div>}
            component={<DateInput tab={key} />}
          />
        </Tab>
        <Tab
          eventKey="ENGAGEMENT_STATUS_REPORT"
          title="Engagement Feedback Report"
          className="border-bottom border-x"
          style={{ height: "28rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Engagement Feedback</div>}
            component={
              <div className="d-flex flex-column gap-4">
                <DateInput tab={key} />
                <CardDiv
                  title={<div className="fs-2 text-black">Notes</div>}
                  component={
                    <div className="">
                      <ol className="fs-1 fw-bold">
                        <li className="">
                          This report generates data that contains all the
                          feedback given for all engagements for latest
                          delivered orders within the date range.
                        </li>
                        <li>
                          For a given date range, there may be multiple
                          engagements for a single order. Ex: In a typical
                          month, 2-3 engagements of the same order may occur.
                        </li>
                        <li>
                          This report also gives a field that indicates whether
                          an order has been placed after the concerned order's
                          engagement. This does not mean that the order was
                          placed after that specific engagement. It's merely an
                          indicator that a new order has come in after the order
                          in concern.
                        </li>
                      </ol>
                    </div>
                  }
                />
              </div>
            }
          />
        </Tab>
        <Tab
          eventKey="ENGAGEMENT_REPORT"
          title="Engagement Report"
          className="border-bottom border-x"
          style={{ height: "33rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Engagement Report</div>}
            component={
              <div className="d-flex flex-column gap-4">
                <DateInput tab={key} />
                <CardDiv
                  title={<div className="fs-2 text-black">Notes</div>}
                  component={
                    <div className="">
                      <ol className="fs-1 fw-bold">
                        <li>
                          This report generates data related to engagements per
                          order. For each order, the latest engagement is shown
                          in this report.
                        </li>
                        <li>
                          This report also calculates if the order has come
                          after the specified engagement is completed.
                        </li>
                        <li>
                          Given the date range, there may be multiple
                          engagements. For example, in a typical month, 2-3
                          engagements of the same order may occur. However, in
                          this case, only the latest valid engagement for that
                          order is shown in this report.
                        </li>
                        <li>
                          If an order (#45678) has two engagements (Week #2 and
                          Week #3) and an order has been placed after Week #2 of
                          this order (#89071), then the report will show that
                          the latter order has come after Week #2.
                        </li>
                        <li>
                          If an order (#45678) has two engagements (Week #2 and
                          Week #3) and no order has been placed after Week #4,
                          then the report will show Week #4 in the report.
                        </li>
                      </ol>
                    </div>
                  }
                />
              </div>
            }
          />
        </Tab>
        <Tab
          eventKey="ADHERENCE_REPORT"
          title="Adherence Report"
          className="border-bottom border-x"
          style={{ height: "15rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Adherence Report</div>}
            component={
              <>
                <DateInput tab={key} />
                <div className="fw-bold mt-4">
                  Please note that this report precomputes various fields for
                  improving performance by running a job every few hours.
                  Therefore its accurate to one day before the current date.
                </div>
              </>
            }
          />
        </Tab>
        <Tab
          eventKey="SALES_REPORT"
          title="Sales Report"
          className="border-bottom border-x"
          style={{ height: "15rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Sales Report</div>}
            component={<DateInput tab={key} />}
          />
        </Tab>
        <Tab
          eventKey="ORDER_LINK"
          title="Order Link Report"
          className="border-bottom border-x"
          style={{ height: "15rem" }}
        >
          <CardDiv
            title={<div className="fs-2">Order Link Report</div>}
            component={<DateInput tab={key} />}
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Reports;
